import { render, staticRenderFns } from "./CallSetUpTimeStatisticsPage.vue?vue&type=template&id=9d5878ee&scoped=true&"
import script from "./CallSetUpTimeStatisticsPage.vue?vue&type=script&lang=js&"
export * from "./CallSetUpTimeStatisticsPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5878ee",
  null
  
)

export default component.exports